import Modal from "@ts-digital/vrc/es/components/modal";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { CustomButton } from "../CustomButton";
import "./style.css";

const fm = getFormattedMessageWithScope("components.PaymentAlreadyExistModal");

interface PaymentAlreadyExistModalProps {
    onAbort: Function;
    onConfirm: Function;
    visible: boolean;
    loading: boolean;
}

export const PaymentAlreadyExistModal = ({
    onAbort,
    onConfirm,
    visible,
    loading,
}: PaymentAlreadyExistModalProps) => {
    return (
        <Modal
            className="c-PaymentAlreadyExistModal"
            visible={visible}
            title={
                <span className="c-PaymentAlreadyExistModal-title">
                    {fm("title")}
                </span>
            }
            onClose={onAbort}
            footer={
                <div className="c-PaymentAlreadyExistModal-footer">
                    <div className="c-PaymentAlreadyExistModal-footer-buttons">
                        <CustomButton
                            kind="secondary"
                            colorScheme="ghost"
                            className="c-PaymentAlreadyExistModal-footer-buttons-abort"
                            onClick={onAbort}
                            disabled={loading}
                        >
                            {fm("abort")}
                        </CustomButton>
                        <CustomButton
                            kind="primary"
                            onClick={onConfirm}
                            loading={loading}
                            disabled={loading}
                        >
                            {fm("proceed")}
                        </CustomButton>
                    </div>
                </div>
            }
        >
            <div className="c-PaymentAlreadyExistModal-content">
                <p>{fm("line1")}</p>
                <p>{fm("line2")}</p>
            </div>
        </Modal>
    );
};
